import React, { useState } from 'react'
import { Helmet } from 'react-helmet'
import { useNavigate } from 'react-router-dom'
import Loader from '../../../components/Loader/Loader'
import { useAllNewsQuery } from '../../../helpers/newsApi'
import { motion } from 'framer-motion';
import { Pagination } from '@mui/material'


function CodeNews() {

  const navigate = useNavigate()

  const [page, setpage] = useState(1)
  const { data, isFetching } = useAllNewsQuery(page)

  return (
    <div className="dark:bg-gray-900 transition-all duration-700">

      <Helmet >
        <title> CodeNews</title>
      </Helmet>

      <div className=' pt-[52px] md:pt-[60px]'>
        <div className=' main-class max-w-screen-xl w-[90%] mx-auto md:w-full  min-h-[77vh] '>
          <h1 className='text-xl md:text-2xl text-center font-bold dark:text-white'>Tech <span className='text-red-500'>News</span></h1>
          <h6
            className='text-center text-gray-600 text-[14px] md:text-xs'
          >
            Bringing Global Startup Innovation & Funding News To You.
          </h6>

          <div>
            {isFetching ? (
              <Loader height={'40vh'} text='Loading News...' />
            ) : (
              <motion.div
                whileInView={{ y: [100, 0], opacity: [0, 1] }}
                transition={{ duration: 1.0, delay: 0.2 }}
                viewport={{ once: true }}
                initial='hidden'
                style={{ opacity: 0 }}

              >
                <div className='grid grid-cols-1 gap-5 my-5 md:my-7  md:grid-cols-2 lg:grid-cols-3'>

                  {data.news.length > 0 && data.news.map((item, i) => (
                    <div key={i} onClick={() => navigate(`/news/${item.slug}`)} className='rounded-xl cursor-pointer hover:scale-105 duration-700 bg-gray-50 shadow-lg hover:shadow-xl'>
                      <img src={item.image} alt="img" className="w-full h-[200px] md:h-[250px] rounded-t-xl" />
                      <div className="p-3">
                        <h1 className="font-bold text-[15px] md:text-[17px] line-clamp-3">
                          {item.title}
                        </h1>
                      </div>
                    </div>
                  ))}
                </div>
              </motion.div>
            )}

            <div className='flex justify-center my-3'>
              {data && data.resultPerPage < data.filteredNewsCount && (

                <Pagination color='primary' size='medium'
                  count={Math.ceil(data.totalNewsCount / data.resultPerPage)}
                  page={page}
                  shape='rounded'
                  onChange={(event, value) => setpage(value)}
                  showLastButton showFirstButton hideNextButton hidePrevButton
                  onClick={() => window.scrollTo(0, 0)}

                />
              )}
            </div>

          </div>

        </div>
      </div>
    </div>
  )
}

export default CodeNews